<template>
  <div class="overflow-hidden">
    <template v-for="c in contents">
      <lazy-strapi-media-gallery
        v-if="c.component === 'media-gallery'"
        :key="`${c.component}__${c.id}`"
        class="mb-16"
        :component="c"
        :show-title="false"
      />

      <lazy-strapi-slide-box
        v-if="c.component === 'home-page.slide-box'"
        :key="`${c.component}__${c.id}`"
        class="max-w-screen-xl mx-auto px-4 mb-16 justify-around 2xl:gap-20"
        :in-container="true"
        :image-has-shadow="false"
        :component="c"
      />
      <lazy-strapi-banner
        v-if="c.component === 'generic.banner'"
        :key="`${c.component}__${c.id}`"
        :component="c"
        full-width-on-mobile
        class="max-w-screen-xl mx-auto px-4 mb-16 pb-8"
      />

      <lazy-strapi-product-locations-map
        v-if="c.component === 'product.locations-map'"
        :key="`${c.component}__${c.id}`"
        class="mt-24 mb-16"
        :full-width="true"
        :component="c"
      />
      <lazy-strapi-product-faq
        v-if="c.component === 'product.faqs'"
        :key="`${c.component}__${c.id}`"
        class="w-full mb-16 mx-auto"
        :component="c"
      />
      <div
        v-if="c.component === 'sustainability.vertical-media-compare'"
        :key="`${c.component}__${c.id}`"
        class="max-w-screen-xl mx-auto px-4 mb-16"
      >
        <lazy-strapi-vertical-media-compare :component="c" />
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import type { StrapiContent } from '~/apollo/types/types';

defineProps<{
  contents: Array<StrapiContent>;
}>();
</script>
